import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { LazyImgDirective } from '../../../shared/utils/directive/lazy-img.directive';
import { DefaultShowHideDirective } from '../../../flex-layout/show-hide';

@Component({
  selector: 'calsoft-home-banner-layout',
  imports: [DefaultLayoutDirective, DefaultFlexDirective, DefaultLayoutGapDirective, DefaultLayoutAlignDirective, LazyImgDirective, DefaultShowHideDirective, ],
  templateUrl: './home-banner-layout.component.html',
  styleUrl: './home-banner-layout.component.scss'
})
export class HomeBannerLayoutComponent implements OnInit {
  @Input() item: any;
  @Input() img: any;
  @Input() bannerWidth: any;
  @Input() bannerHeight: any;
  @Input() bannerMobWidth: any;
  @Input() bannerMobHeight: any;
  @Input() bannerTabletHeight:any;
  @Input() bannerTabletWeight:any;
  
  public serverPath = environment.commonImageApi + '/home/';
  imageUrl: string|any;
  public url = environment.commonImageApi;
  bannertextset:any;
  constructor(
  ) { }

  ngOnInit(): void {

    this.imageUrl = this.url + "commonSlider/";
    this.bannertextset = this.img[0].customField29;

  }



}
